import { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'startTrial',
	dialogId: 'plan-selection-page-modal',
	dialogType: 'modal',
};
